import { SideNavHeader } from '@/components/layout/side-nav'
import { Badge } from '@/components/ui/badge'
import { getAssetLink } from '@/helpers/get-asset-link'
import { Building } from '@/reducers/types'

import { PlaceStatusBadge } from '../place-status-badge'
import { getBuildingPms, PMS_LABELS } from '../places.pms'
import { getPlaceName, getPlaceStatus } from '../places.utils'

export const PlaceNavHeader = ({ building }: { building: Building }) => {
  const pms = getBuildingPms(building)

  return (
    <SideNavHeader
      avatarSrc={getAssetLink({ file: building.logo ?? undefined, path: 'chitown-building' })}
      badges={
        <>
          <PlaceStatusBadge status={getPlaceStatus(building)} />
          {pms && (
            <Badge color="blue" size="small" variant="light">
              {PMS_LABELS[pms]}
            </Badge>
          )}
        </>
      }
      subtitle={building.code}
      title={getPlaceName(building)}
    />
  )
}
